export const locale = {
    lang: 'en',
    data: {
        DATE_LABEL: {
            TITLES: {
                TODAY: 'Today'
            }
        }
    }
};